<template>
  <div>
    <MainForm
      :name="FORM_NAMES.eligibility"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :ui-form="uiForm"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      ui-title="Striver card application"
    >
      <!-- <CardReader /> -->
      <StepModel
        :ui="uiBasePersonal"
        :name="STEP_NAMES.welcome"
        ui-title="Contact Information"
        ui-subtitle="We need to ask you a few questions to create your profile"
        ui-error-message="Please review the fields marked in red"
      >
        <div v-if="isVisbielDot">
          <FieldsetModel
            :ui="uiBaseFieldset"
            name="FIELDSET_NAMES.customerConsent"
          >
            <p class="saving" id="spinner2">
              <span class="dot"></span>
              <span class="dotText">Give us few seconds...</span>
            </p>
          </FieldsetModel>
        </div>
        <div v-else></div>
       <FieldsetFullName :fieldset-name="FIELDSET_NAMES.fullNameReview" />
      
       <FieldsetEmail />
        <FieldsetMobilePhone title="Your mobile number is" />
      </StepModel>
      <StepContact :validateFn="validateCustmerContact" />
      <StepModel
        :ui="uiBasePersonal"
        :name="STEP_NAMES.eligibility"
        ui-title="Profile Information"
        ui-subtitle="We need to ask you a few questions to check if you are eligible for this product"
        ui-error-message="Please review the fields marked in red"
      >
      <!-- :default-value="maritalStatus" -->
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.maritalStatus"
          ui-title="You are"
        >
          <UiWrapper :name="FIELD_NAMES.maritalStatus" >
            <Choice :options="MARITAL_STATUS"  />
          </UiWrapper>
        </FieldsetModel>

        <!-- <FieldsetBornDate title="Your date of birth" label="Your date of birth" /> -->
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.living"
          ui-title="You have lived in the UAE for"
        >
          <UiWrapper :name="FIELD_NAMES.livingTime">
            <Dropdown
              placeholder="Select a time range"
              :options="[
                { value: '0-5 Months', label: '0-5 Months' },
                { value: '6-11 Months', label: '6-11 Months' },
                { value: '12-17 Months', label: '12-17 Months' },
                { value: '18-23 Months', label: '18-23 Months' },
                { value: '24-35 Months', label: '24-35 Months' },
                { value: '36-47 Months', label: '36-47 Months' },
                { value: '48-59 Months', label: '48-59 Months' },
                { value: '60-71 Months', label: '60-71 Months' },
                { value: '72+ Months', label: '72+ Months' },
              ]"
            />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.residenceType"
          ui-title="You live in a"
        >
          <UiWrapper :name="FIELD_NAMES.residenceType">
            <Dropdown
              placeholder="Select your type of residence"
              :options="residenceTypes"
            />
          </UiWrapper>
        </FieldsetModel>
        <!-- :default-value="getEmiratesWork" -->
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.areaOfWork"
          ui-title="Your office is in"
        >
          <UiWrapper :name="FIELD_NAMES.areaOfWork" >
            <Dropdown
              placeholder="Select Emirate"
              :options="EMIRATE_LIST_CARD"
            />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.fixedIncomeFieldset"
          ui-title="What is your fixed monthly income?"
        >
          <FieldIncome
            :name="FIELD_NAMES.fixedIncome"
            label="Enter your monthly income in AED"
          />
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.variableIncomeFieldset"
          ui-title="What is your variable monthly income?"
        >
          <FieldsetVariableIncome
            :name="FIELD_NAMES.variableIncome"
            label="Enter your variable income in AED"
            :optional="true"
          />
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.mediumOfReceiveFieldSet"
          ui-title="How do you receive your monthly income?"
        >
          <UiWrapper :name="FIELD_NAMES.mediumOfReceive">
            <Dropdown
              placeholder="Select the mode"
              :options="[
                { value: 'Bank account', label: 'Bank account' },
                { value: 'Exchange house', label: 'Exchange house' },
                { value: 'Cash', label: 'Cash' },
                { value: 'Cheque', label: 'Cheque' },
              ]"
            />
          </UiWrapper>
        </FieldsetModel>
        <!-- End code commented by Attra for the enhancement -->
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.instalmentsAmount"
          :presence="productIs(BRAND.loan)"
          ui-title="In how many years would you like to repay this loan?"
        >
          <UiWrapper :name="FIELD_NAMES.instalmentsAmount">
            <Dropdown
              placeholder="Select loan tenor"
              :options="[
                { value: '1', label: '1 year' },
                { value: '2', label: '2 years' },
                { value: '3', label: '3 years' },
                { value: '4', label: '4 years' },
              ]"
            />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.haveLoansOrCreditCards"
          ui-title="Do you currently have any loans or credit cards?"
          ui-columns="2"
        >
          <UiWrapper
            :name="FIELD_NAMES.haveLoan"
            :default-value="false"
            ui-title="What is the total amount you pay every month for all your loan instalments?"
          >
            <IncomeSwitcher
              switch-label="Loan"
              input-label="Enter your total monthly instalments"
            />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.haveCreditCard"
            :default-value="false"
            ui-title="What is the total credit limit of all your credit cards?"
          >
            <IncomeSwitcher
              switch-label="Credit Card"
              input-label="Enter total limit for all credit cards"
            />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.paymentHoliday"
          ui-title="Do you have right now, a payment holiday in place, for which you asked in context of COVID 19?"
        >
          <UiWrapper :name="FIELD_NAMES.paymentHoliday">
            <Choice :options="PAYMENT_HOLIDAY_STATUS" />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.promoCodeDetails"
          ui-title="Do you have promo code?"
        >
          <UiWrapper
            :name="FIELD_NAMES.promoCode"
            :default-value="isPromoCodeChecked"
          >
            <Choice
              :options="[
                {
                  value: 'Y',
                  label: 'Yes',
                },
                {
                  value: 'N',
                  label: 'No',
                },
              ]"
            />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.promoCodeFields"
          :presence="isPromoCode"
          ui-columns="2"
        >
          <UiWrapper
            :name="FIELD_NAMES.promoCodeInput"
            label="Promo code"
            :default-value="isSourceVirgin"
          >
            <InputText />
          </UiWrapper>

          <UiWrapper :name="FIELD_NAMES.promoCodeButton" optional>
            <Button
              type="button"
              color="white"
              :click="applyPromo"
              id="promoButton"
            >
              <a href="#">Apply</a>
            </Button>
          </UiWrapper>
        </FieldsetModel>

        <FieldsetModel
          :ui="uiBaseFieldset"
          :ui-subtitle="``"
          name="PromoCodeMessage"
        >
          <p hidden class="saving" id="spinner">
            <span class="dot"></span>
            <span class="dotText">Give us few seconds...</span>
          </p>
          <p id="promoMessage"></p>
        </FieldsetModel>
      </StepModel>
      <!-- <StepPersonalInfo /> -->

      <!-- <StepOCREmirates /> -->
      <StepIdentityReview :show-name-fields="hasUploadedIDCard" />
      <!--EmiratesId details-->
     
      <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.employment"
        :ui-title="employmentInfo"
        ui-subtitle="Perfect! Tell us about your work."
        ui-error-message="Please review the fields marked in red"
      >
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.employmentType"
          ui-title="Your work email address is"
          ui-subtitle="We will send you a link on this email for you
          to verify that you have access to it."
        >
          <UiWrapper
            :name="FIELD_NAMES.workEmail"
            label="Work email address"
            :validations="[
              {
                errorMessage: 'Please type a valid email',
                condition: patternCondition(EMAIL_VALIDATION_PATTERN),
                name: 'check-is-email',
              },
            ]"
          >
            <InputText />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.employmentDetailsType"
          ui-title="Choose your employment type"
        >
          <UiWrapper :name="FIELD_NAMES.employmentType">
            <Choice
              :options="[
                {
                  value: 'Salaried',
                  label: 'Salaried',
                },
                {
                  value: 'Self-employed',
                  label: 'Self-employed',
                },
              ]"
            />
          </UiWrapper>
        </FieldsetModel>

        <FieldsetModel
          :presence="isSalaried"
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.workInformationSalaried"
          ui-title="Details of employment"
          ui-columns="2"
        >
          <UiWrapper
            :name="FIELD_NAMES.companyName"
            label="Type the name of your company"
            :validations="[
              {
                errorMessage: 'This field must not be empty',
                condition: notEmptyCondition,
                name: 'companies-filled',
              },
            ]"
          >
            <Suggest
              data-forced-fullwidth="true"
              :exact-match="false"
              placeholder="Type the name of your company"
              :get-formatted-item="formatMatchedString"
              :get-suggestions="getCompanies"
            />+
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.unlistedCompanyName"
            label="Type the name of your company"
            :presence="isOther"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.designation">
            <Dropdown
              placeholder="Choose your designation"
              :options="[
                { value: 'Accountant', label: 'Accountant' },
                { value: 'Administrator', label: 'Administrator' },
                { value: 'Architect', label: 'Architect' },
                { value: 'Barber', label: 'Barber' },
                { value: 'Beautician', label: 'Beautician' },
                { value: 'Broker', label: 'Broker' },
                { value: 'Cabin Crew', label: 'Cabin Crew' },
                {
                  value: 'Call Center Executive',
                  label: 'Call Center Executive',
                },
                { value: 'Cargo', label: 'Cargo' },
                { value: 'Handler', label: 'Handler' },
                { value: 'Carpenter', label: 'Carpenter' },
                { value: 'Chargehand', label: 'Chargehand' },
                {
                  value: 'Chartered Accountant / CPA',
                  label: 'Chartered Accountant / CPA',
                },
                { value: 'Chef / Cook', label: 'Chef / Cook' },
                { value: 'Cleaner', label: 'Cleaner' },
                { value: 'Clerk', label: 'Clerk' },
                { value: 'Consultant', label: 'Consultant' },
                { value: 'Customer Service', label: 'Customer Service' },
                { value: 'Deck hand', label: 'Deck hand' },
                { value: 'Delivery boy', label: 'Delivery boy' },
                { value: 'Denter', label: 'Denter' },
                { value: 'Designer', label: 'Designer' },
                { value: 'Diver', label: 'Diver' },
                { value: 'Doctor', label: 'Doctor' },
                { value: 'Draftsman', label: 'Draftsman' },
                { value: 'Dredger', label: 'Dredger' },
                { value: 'Driver', label: 'Driver' },
                { value: 'Driving instructor', label: 'Driving instructor' },
                { value: 'Electrician', label: 'Electrician' },
                { value: 'Engineer', label: 'Engineer' },
                { value: 'Fabricator', label: 'Fabricator' },
                { value: 'Fireman', label: 'Fireman' },
                { value: 'Foreman', label: 'Foreman' },
                { value: 'Housewife', label: 'Housewife' },
                {
                  value: 'IT Executive / Professional',
                  label: 'IT Executive / Professional',
                },
                { value: 'LABORER', label: 'LABORER' },
                { value: 'Lawyer', label: 'Lawyer' },
                { value: 'Machine operator', label: 'Machine operator' },
                { value: 'Manager', label: 'Manager' },
                { value: 'Mechanic', label: 'Mechanic' },
                { value: 'Messenger', label: 'Messenger' },
                { value: 'Nurse', label: 'Nurse' },
                { value: 'Office boy', label: 'Office boy' },
                { value: 'Officer', label: 'Officer' },
                { value: 'Optician', label: 'Optician' },
                { value: 'Others', label: 'Others' },
                { value: 'Painter', label: 'Painter' },
                { value: 'Peon', label: 'Peon' },
                { value: 'Pharmacist', label: 'Pharmacist' },
                { value: 'Plumber', label: 'Plumber' },
                { value: 'Policeman', label: 'Policeman' },
                { value: 'PRO', label: 'PRO' },
                {
                  value: 'Professor / Academician',
                  label: 'Professor / Academician',
                },
                { value: 'Retired', label: 'Retired' },
                { value: 'Sales Executive', label: 'Sales Executive' },
                { value: 'Secretary', label: 'Secretary' },
                { value: 'Security guard', label: 'Security guard' },
                { value: 'Senior Management', label: 'Senior Management' },
                { value: 'Store Keeper', label: 'Store Keeper' },
                { value: 'Student', label: 'Student' },
                { value: 'Supervisor', label: 'Supervisor' },
                {
                  value: 'Surveyor / Estimator',
                  label: 'Surveyor / Estimator',
                },
                { value: 'Tailor', label: 'Tailor' },
                { value: 'Teacher', label: 'Teacher' },
                { value: 'Technician', label: 'Technician' },
                { value: 'Teller / Cashier', label: 'Teller / Cashier' },
                { value: 'Unemployed', label: 'Unemployed' },
                { value: 'Waiter', label: 'Waiter' },
                { value: 'Welder', label: 'Welder' },
                { value: 'Other', label: 'Other' },
              ]"
            />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.workAmount"
            label="How long you have been working here"
            :validations="[
              {
                errorMessage: 'Please type a past date',
                condition: isPastDateCondition,
                name: 'birth-is-pastdate',
              },
              {
                errorMessage: 'Please enter a valid date',
                condition: isValidDateCondition,
                name: 'is-valid-date',
              },
            ]"
          >
            <DateWrapper />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.industryTypeEmplyoed">
            <Dropdown
              placeholder="Which industry does your company belong to?"
              :options="INDUSTRY_TYPES"
            />
          </UiWrapper>
        </FieldsetModel>

        <FieldsetModel
          :presence="isSelfEmployed"
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.workInformationSelfEmployed"
          ui-title="Details of employment"
          ui-columns="2"
        >
          <UiWrapper
            :name="FIELD_NAMES.companyNameSelfEmployed"
            label="Type the name of your company"
          >
            <InputText />
          </UiWrapper>

          <UiWrapper :name="FIELD_NAMES.designation">
            <Dropdown
              placeholder="Choose your designation"
              :options="[
                { value: 'Director', label: 'Director' },
                { value: 'Managing Director', label: 'Managing Director' },
                { value: 'Partner', label: 'Partner' },
                { value: 'Proprietor', label: 'Proprietor' },
                { value: 'Other', label: 'Other' },
              ]"
            />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.companyAge"
            label="How old is your company"
            :validations="[
              {
                errorMessage: 'Please type a past date',
                condition: isPastDateCondition,
                name: 'birth-is-pastdate',
              },
              {
                errorMessage: 'Please enter a valid date',
                condition: isValidDateCondition,
                name: 'is-valid-date',
              },
            ]"
          >
            <DateWrapper />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.industryTypeSelfEmplyoed">
            <Dropdown
              placeholder="Which industry does your company belong to?"
              :options="INDUSTRY_TYPES"
            />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.primaryAddress"
          :ui-title="titleOfffice"
        >
          <UiWrapper :name="FIELD_NAMES.primaryAddress">
            <Choice
              :options="[
                {
                  value: 'BUSINESS',
                  label: 'Office',
                },
              ]"
            />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel :ui="uiBaseFieldset" :name="name" ui-columns="2">
          <UiWrapper
            :name="FIELD_NAMES.addressLine1"
            label="Address Line 1"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.addressLine2"
            label="Address Line 2"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.residentialEmirate"
            label="Emirate"
            optional
          >
            <Dropdown
              placeholder="Emirate"
              v-bind:selected="`selected`"
              :options="EMIRATE_LIST_CARD"
            />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.homeCountryCountry"
            label="Country"
            optional
          >
            <Suggest
              :exact-match="true"
              placeholder="Country"
              :get-formatted-item="formatMatchedString"
              :get-suggestions="getCountriesAppointment"
            />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.poBox"
            label="PO Box"
            optional
            :validations="pinCodeValidations"
          >
            <InputText />
          </UiWrapper>
        </FieldsetModel>
        <!--      
        <div v-if="isVisible">
          <FieldsetModel
            :ui="uiBaseFieldset"
            :name="FIELDSET_NAMES.incomeIbanBankAccount"
            ui-title="Which bank do you receive your salary in? "
          >
            <UiWrapper
              :name="FIELD_NAMES.bankAccount"
              label="Select a bank from the list"
              :on-change="
                resetTransactionServiceAndFields(INCOME_UPLOAD_FIELDS)
              "
              :validations="[
                {
                  errorMessage: 'This field must not be empty',
                  condition: notEmptyCondition,
                  name: 'institution-filled',
                },
              ]"
            >
              <Suggest
                placeholder="Select a bank from the list"
                :exact-match="true"
                :get-formatted-item="formatMatchedString"
                :get-suggestions="getBanksForBt"
              />
            </UiWrapper>
          </FieldsetModel>

         
        </div>
        <div v-else></div> -->
      </StepModel>
      <div>
        <StepIban />
        <!-- <StepStatementUpload /> -->
      </div>
    </MainForm>
  </div>
</template>
<script>
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import STEP_NAMES from "@/forms/constants/step-names";
import FIELDSET_NAMES from "@/forms/constants/fieldset-names";
// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";
import UploadWrapper from "@/forms/components/ui-dunia/upload-wrapper";
import IncomeSwitcher from "@/forms/components/ui-dunia/income-switcher";
import FieldIncome from "@/forms/components/shared/fields/income";
import FieldsetVariableIncome from "@/forms/components/shared/fields/variable-income";
import StepContact from "@/forms/components/shared/steps/contact-verification";
import CardReader from "@/forms/components/shared/steps/card-reader";
import getValueFromCookie from "@/forms/helpers/get-value-from-cookie";
// Ui Components
import {
  InputText,
  InputSlide,
  Choice,
  Suggest,
  Dropdown,
  InputPassword,
  Expandable,
  Button,
} from "@dunia/ui";

// Utils
import CheckWrapper from "@/forms/components/ui-dunia/check-wrapper";
import getLastEditValue from "@/forms/helpers/get-last-edit-value";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import Vue from "vue";
import * as conditions from "@/forms/conditions";
import { patternCondition } from "@/forms/conditions";
// Services
import bankPerfioService from "@/forms/api/services/bank-perfio";
import uploadService from "@/forms/api/services/upload";
import promoCodeService from "@/forms/api/services/validate-promo-code";
import formService from "@/forms/api/services/form";
import flowManager from "@/lib/services/flow-manager";
import otpServiceReferal from "@/forms/api/services/otp-referral";
import sleep from "@/forms/helpers/sleep";
// Constants
import {
  MIN_FIXED_INCOME,
  MOBILE_STARTING_NUMBER,
  MOBILE_NUMBER_LENGTH,
  MOBILE_NUMBER_LENGTH_GLOBAL,
  DIGIT_CHARS,
  ADDRESS_CHARS,
  EMAIL_VALIDATION_PATTERN,
  NAMES_CHARS,
  MIN_AGE
} from "@/forms/constants/onboarding-logic";
import FIELD_NAMES from "@/forms/constants/field-names";
import StepIban from "@/forms/components/cards/stp-card/steps/iban";
import StepOtp from "@/forms/components/cards/stp-card/steps/otp";
import StepPersonalInfo from "@/forms/components/cards/stp-card/steps/personal-information";
import FieldsetEmail from "@/forms/components/shared/fieldsets/email";
import FieldsetBornDate from "@/forms/components/shared/fieldsets/born-date";
import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetIBAN from "@/forms/components/shared/fieldsets/iban-number";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";
import StepOCREmirates from "@/forms/components/cards/stp-card/steps/ocr-emirates";
import StepIdentityReview from "@/forms/components/cards/credit-card/steps/identity-review";
import StepStatementUpload from "@/forms/components/shared/steps/upload-statements";
import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import DateWrapper from "@/forms/components/ui-dunia/date-wrapper";
//API
import automationApiService from "@/forms/api/services/automation-api";
import {
  SET_BANK_NAME,
  SET_FIRST_NAME,
  SET_SECOND_NAME,
  SET_BASIC_ELIGIBILITY,
  SET_PRODUCT_TYPE,
  SET_INELIGIBLE_EMIRATES,
  SET_EMPLOYMENT_TYPE,
  SET_PROMO_CODE_RESPONSE,
  SET_PROMO_CODE_STATUS,
  SET_INELIGIBLE_MEDIUM_OF_RECEIVE,
  SET_JOB_VINTAGE,
  SET_CUSTOMER_CONSENT,
  SET_INCOME_FIXED,
} from "@/lib/constants/mutations";

import { parse } from "path";
//Store
import store from "@/store";
import { type } from "os";
import { watch } from "fs";
const UPLOAD_FILE_NAMES = [
  FIELD_NAMES.firstSalaryFile,
  FIELD_NAMES.secondSalaryFile,
  FIELD_NAMES.thirdSalaryFile,
];
export default {
  name: "OnboardDunia",
  mixins: [FormComponentMixin],
  components: {
    //Components
    MainForm,
    StepModel,
    FieldsetModel,
    Dropdown,
    Choice,
    Suggest,
    InputText,
    InputSlide,
    UiWrapper,
    UploadWrapper,
    IncomeSwitcher,
    StepOtp,
    StepPersonalInfo,
    FieldsetEmail,
    FieldsetBornDate,
    FieldsetMobilePhone,
    FieldsetFullName,
    StepOCREmirates,
    StepIdentityReview,
    FieldIncome,
    FieldsetVariableIncome,
    InputPassword,
    CheckWrapper,
    Expandable,
    StepStatementUpload,
    Button,
    FieldsetIBAN,
    StepIban,
    DateWrapper,
    StepContact,
    CardReader,
  },
  props: {
    titleMob: {
      type: String,
      default: "Customer Mobile Number",
    },
    subtitleMob: {
      type: String,
      default: "",
    },
    labelMob: {
      type: String,
      default: "Mobile number",
    },
    name: {
      type: String,
      default: FIELDSET_NAMES.appointmentSetDate,
    },
    titleOfffice: {
      type: String,
      default: "Please enter your Office address below",
    },
    titleHome: {
      type: String,
      default: "Please enter your UAE residential address below",
    },
    defaultCountry:{
      type: String,
     default: "United Arab Emirates"
    },
    timeOptions: {
      type: Array,
      default: () => [
        {
          value: "7am - 9am",
          label: "7am - 9am",
        },
        {
          value: "9am - 11am",
          label: "9am - 11am",
        },
        {
          value: "11am - 1pm",
          label: "11am - 1pm",
        },
        {
          value: "1pm - 3pm",
          label: "1pm - 3pm",
        },
        {
          value: "3pm - 5pm",
          label: "3pm - 5pm",
        },
        {
          value: "5pm - 7pm",
          label: "5pm - 7pm",
        },
      ],
    },
    validations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-mobile-only-digits",
        },
        {
          errorMessage: "Your phone must start with a 5",
          condition: conditions.patternCondition(MOBILE_STARTING_NUMBER),
          name: "check-is-mobile-starting-number",
        },
        {
          errorMessage: "Your phone must have 9 digits",
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH),
          name: "check-is-mobile-length",
        },
      ],
    },
    validationsGlobal: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-mobile-only-digits",
        },

        {
          errorMessage: "Your phone must be between 9-11 digits",
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH_GLOBAL),
          name: "check-is-mobile-length",
        },
      ],
    },
    addressValidations: {
      type: Array,
      default: () => [
        {
          errorMessage:
            "Field contains invalid characters. Albhabets, Numbers and special character (- , / space) are allowed.",
          condition: patternCondition(ADDRESS_CHARS),
          name: "address-chars",
        },
      ],
    },
    pinCodeValidations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Field contains invalid characters.",
          condition: patternCondition(DIGIT_CHARS),
          name: "pincode-chars",
        },
      ],
    },
    emailValidations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Please type a valid email",
          condition: conditions.patternCondition(EMAIL_VALIDATION_PATTERN),
          name: "check-is-email",
        },
      ],
    },
      mobileValidations: {
      type: Array,
      default: () => ([
        {
          errorMessage: 'Invalid character',
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: 'check-is-mobile-only-digits',
        },
        {
          errorMessage: 'Your phone must start with a 5',
          condition: conditions.patternCondition(MOBILE_STARTING_NUMBER),
          name: 'check-is-mobile-starting-number',
        },
        {
          errorMessage: 'Your phone must have 9 digits',
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH),
          name: 'check-is-mobile-length',
        },
      ]),
    },
     birthDateValidations: {
      type: Array,
      default: () => ([
        {
          errorMessage: 'Please type a past date',
          condition: conditions.isPastDateCondition,
          name: 'birth-is-pastdate',
        },
        // {
        //   errorMessage: 'You must be under 60 years old',
        //   condition: conditions.maxYearCondition(MAX_AGE),
        //   name: 'age-is-under-60',
        // },
        {
          errorMessage: 'You must be at least 21 years old',
          condition: conditions.minYearCondition(MIN_AGE),
          name: 'age-is-above-21',
        },
      ]),
    },
    prefix: {
      type: String,
      default: "+971",
    },
    maxlength: {
      type: Number,
      default: 9,
    },
    minlength: {
      type: Number,
      default: 9,
    },
    minlengthGlobal: {
      type: Number,
      default: 11,
    },
    isProgress: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    NAMES_CHARS,
     MOBILE_STARTING_NUMBER,
  MOBILE_NUMBER_LENGTH,
  DIGIT_CHARS,
    ID_FIELDS: [FIELD_NAMES.emiratesFrontCard, FIELD_NAMES.emiratesBackCard],
    INCOME_UPLOAD_FIELDS: [
      FIELD_NAMES.firstStatement,
      FIELD_NAMES.secondStatement,
      FIELD_NAMES.thirdStatement,
      FIELD_NAMES.consolidatedStatement,
    ],
    UPLOAD_FILE_NAMES,
    uploadedFiles: [false, true, true],
    INSTALMENT_PERIOD: FIELD_NAMES.instalmentsAmount,
    state: {
      date: new Date(2016, 9, 16),
    },

    applied: false,
    promoCodeDomMessage: "",
    profileTitle: "Profile Information",
    employmentInfo: "Employment Information",
    isVisible: true,
    search: "",
  }),
  async created() {
    var currentStep = this.STEP_NAMES.welcome;
      await automationApiService.getAutomationApi(currentStep, this);
        this.isProgress = false;
      // spinner2.removeAttribute("hidden");
    // await sleep(5000);
    //       spinner2.setAttribute("hidden", "");
  },

  async beforeMount() {},
  async mounted() {

 
  },

  async beforeUpdate() {
    //      const spinner2 = document.getElementById("spinner2");
    //       console.log('mounted');
    //       console.log(spinner2)
    //     //  spinner2.removeAttribute("hidden");
    //await sleep(5000);
    //       spinner2.setAttribute("hidden", "");
    //  console.log('mounted2');

  
  },
  updated: function () {
    var promoButton = document.getElementById("promoButton");
    var promoChoice = document.getElementsByName("promoCode")[0];
    var buttonProfile = document.getElementById("profileSubmit");
    var promoCodeMessage = document.getElementById("promoMessage");
    var phoneNumber = document.getElementsByName("phoneNumber")[0];
    const { values } = store.state.formData;
    if (promoButton) {
      promoButton.style.border = "none";
    }
    if (promoChoice) {
      if (this.fieldValues(FIELD_NAMES.promoCode) === "Y") {
        this.applied = true;
        buttonProfile.disabled = true;
      } else {
        buttonProfile.disabled = false;
      }
    }
    let bankName = this.$store.state.institutions.find((obj) => {
      return obj.id === this.fieldValues(FIELD_NAMES.bankAccount);
    });
    if (typeof bankName !== "undefined") {
      store.commit(SET_BANK_NAME, { bankName: bankName.name });
    }
    store.commit(SET_FIRST_NAME, {
      firstName: this.fieldValues(FIELD_NAMES.firstName),
    });
    store.commit(SET_SECOND_NAME, {
      lastName: this.fieldValues(FIELD_NAMES.lastName),
    });
    store.commit(SET_BASIC_ELIGIBILITY, {
      basicEligibility5000: this.fieldValues(FIELD_NAMES.fixedIncome),
    });
    store.commit(SET_INELIGIBLE_EMIRATES, {
      ineligibleEmirates: this.fieldValues(FIELD_NAMES.areaOfWork),
    });
    store.commit(SET_EMPLOYMENT_TYPE, {
      employmentType: this.fieldValues(FIELD_NAMES.employmentType),
    });
    store.commit(SET_INELIGIBLE_MEDIUM_OF_RECEIVE, {
      ineligibleMediumOfReceive: this.fieldValues(FIELD_NAMES.mediumOfReceive),
    });
    store.commit(SET_INCOME_FIXED, {
      incomeFixed: this.fieldValues(FIELD_NAMES.fixedIncome),
    });
    if (this.fieldValues(FIELD_NAMES.employmentType) === "Salaried") {
      store.commit(SET_JOB_VINTAGE, {
        jobVintage: this.fieldValues(FIELD_NAMES.workAmount),
      });
    } else if (
      this.fieldValues(FIELD_NAMES.employmentType) === "Self-employed"
    ) {
      store.commit(SET_JOB_VINTAGE, {
        jobVintage: this.fieldValues(FIELD_NAMES.companyAge),
      });
    }
    this.isBankFieldsVisible(this.fieldValues(FIELD_NAMES.mediumOfReceive));
  },

  computed: {
    isPromoCode() {
      return this.fieldValues(FIELD_NAMES.promoCode) === "Y";
    },
    getCountSalariesUploaded() {
      return this.uploadedFiles.filter((uploaded) => uploaded).length;
    },
    variableIncomePresence() {
      const value = getLastEditValue(FIELD_NAMES.fixedIncome);
      const parsedIncome = parseFloat(value);
      return parsedIncome < MIN_FIXED_INCOME;
    },
    isSalaried() {
      return this.fieldValues(FIELD_NAMES.employmentType) === "Salaried";
    },
    isSelfEmployed() {
      return this.fieldValues(FIELD_NAMES.employmentType) === "Self-employed";
    },
    isSingleDocument() {
      return (
        this.fieldValues(FIELD_NAMES.statementType) === "Consolidated Statement"
      );
    },
    isMultipleDocument() {
      return (
        this.fieldValues(FIELD_NAMES.statementType) === "Monthly Statements"
      );
    },
    promoCodeResponseText() {
      return typeof this.$store.state.promoCodeResponse !== "undefined"
        ? this.$store.state.promoCodeResponse
        : "";
    },
    isIBANScreen() {
      return this.getEmpInfoResponse();
    },
    isMobileNumber() {
      //  if(this.fieldValues(FIELD_NAMES.phoneNumber))
      //  {
      return this.fieldValues(FIELD_NAMES.phoneNumber);
      //}
    },

    isQueryStringURL(value) {
      var queryStringObj = JSON.stringify(this.$store.state.querystrings);
      if (value.length > 0) {
        if (queryStringObj.includes(value)) {
          return false;
        }
      }

      if (value.length <= 0) {
        if (queryStringObj.includes("notVerified")) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    },
    isOther() {
      var companyName =
        "" + this.fieldValues(FIELD_NAMES.companyName) + "".toUpperCase();
      if (
        companyName === "UNLISTED COMPANY" ||
        companyName === "DIGITAL TEMP" ||
        companyName === "OTHER" ||
        companyName === "OTHERS"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isSourceVirgin() {
      if (
        "" + this.$store.state.source + "".toUpperCase() === "VIRGIN" ||
        "" + this.$store.state.source + "".toLowerCase() === "virgin" ||
        this.$store.state.source === "Virgin"
      ) {
        return this.$store.state.source;
      }
    },
    isPromoCodeChecked() {
      if (
        "" + this.$store.state.source + "".toUpperCase() === "VIRGIN" ||
        "" + this.$store.state.source + "".toLowerCase() === "virgin" ||
        this.$store.state.source === "Virgin"
      ) {
        return "Y";
      }
    },
    isVisbielDot() {
      if (this.isProgress) {
        return true;
      } else {
        return false;
      }
    },
    personalEmail() {
      return this.$store.state.automationResponse["email"];
    },
    maritalStatus() {
      if (
        "" +
          this.$store.state.automationResponse["maritalStatusCode"] +
          "".toUpperCase() ===
        "MARRIED"
      ) {
        return "Married";
      } else {
        return "Single";
      }
    },
    getFirstName() {
      var name =
        "" + this.$store.state.automationResponse["fullNameEnglish"] + "";
      var copyName = name.replace(",,,,", ",");
      var firstName = copyName.split(",");
      return firstName[0];
    },
       getLastName() {
      var name =
        "" + this.$store.state.automationResponse["fullNameEnglish"] + "";
      var copyName = name.replace(",,,,", ",");
      var lastName = copyName.split(",");
      return lastName[1];
    },
    getMobileNumber(){
      var m1=''+this.$store.state.automationResponse['mobilePhoneNumber']+'';
      var m2 = m1.substring(1);
      return m2;
    },
    getEmiratesWork(){
      return this.$store.state.automationResponse['cityDescEnglishWork'];
    },
    getDateOfBirth(){
return this.$store.state.automationResponse['dateOfBirth'];
    },
     getPassportNumber(){
      return this.$store.state.automationResponse['passportNumber'];
    },
    getPassportExpiryDate(){
return this.$store.state.automationResponse['passportExpiryDate'];
    },
    getNationalityCode(){
return this.$store.state.automationResponse['nationalityEnglish'];
    },
    
  },
  methods: {
    getValueFromCookie,
    async applyPromo(event) {
      this.applied = true;
      var promoMessage = document.getElementById("promoMessage");
      var promoCodeInput = document.getElementsByName("promoCodeInput")[0];
      promoMessage.innerHTML = "";
      event.preventDefault();
      var button = document.getElementById("profileSubmit");
      const spinner = document.getElementById("spinner");

      spinner.removeAttribute("hidden");
      var currentStep = this.STEP_NAMES.eligibility;
      if (this.fieldValues(FIELD_NAMES.promoCodeInput)) {
        await promoCodeService.validatePromoCode(currentStep, this);
        var promocodeMessage = this.$store.state.promoCodeResponse;
        var promoCodeStatus = this.$store.state.promoCodeStatus;

        if (promoCodeStatus === "INVALID" || "EXPIRED") {
          promoMessage.innerHTML = promocodeMessage;
          promoMessage.style.color = "#ff0000";

          promoCodeInput.value = "";
        }
        if (promoCodeStatus === "SUCCESS") {
          promoMessage.style.color = "#6e3dea";
          promoMessage.innerHTML = promocodeMessage;
          promoCodeInput.value = this.fieldValues(FIELD_NAMES.promoCodeInput);
        }

        if (!promoCodeStatus) {
          promoMessage.style.color = "#ff0000";
          promoCodeInput.value = this.fieldValues(FIELD_NAMES.promoCodeInput);
          promoMessage.innerHTML =
            "Oops! an error occured while processing your request.";
        }
      } else {
        document.getElementById("promoMessage").style.color = "#ff0000";
        promoMessage.innerHTML = "promo code must not be empty.";
      }
      button.disabled = false;
      spinner.setAttribute("hidden", "");
    },

    ...conditions,
    salaryVerification: uploadService.salaryVerification,
    increaseSalariesUploaded(index) {
      Vue.set(this.uploadedFiles, index, true);
    },
    isBankFieldsVisible(value) {
      if (value === "Bank account") {
        this.isVisible = true;
      } else if (value === "Exchange house") {
        this.isVisible = false;
      }
    },
    persistStep2() {
      return formService.sendFormWithoutBlock();
    },

    getEmpInfoResponse() {
      var empStatus = this.$store.state.appianEmpInfo;
      if (empStatus == "Technical Error") {
        return true;
      }
    },
    getEmpInfoResponse2() {
      var empStatus = this.$store.state.appianEmpInfo;
      if (typeof empStatus == "Success") {
        return true;
      }
    },
    async validateCustmerContact() {
      const spinner = document.getElementById("spinner");
      var currentStep = this.STEP_NAMES.contactCodeVerification;
      spinner.removeAttribute("hidden");
      var consent = await otpServiceReferal.validateAndBlockCustomerConsent(
        currentStep,
        this
      );

      store.commit(SET_CUSTOMER_CONSENT, { customerConsent: consent });

      if (consent) {
        document.getElementById("firstSpan").style.display = "none";
        document.getElementById("linkButton").style.display = "none";
        document.getElementById("thirdSpan").style.display = "none";
        document.getElementById("secondSpan").innerHTML =
          "Customer application has been verified successfully.";
        await sleep(2000);
        spinner.setAttribute("hidden", "");
        flowManager.goToNextStep({
          stepToGo: this.STEP_NAMES.eligibility,
          skipValidations: true,
        });
      } else {
        document.getElementById("firstSpan").style.display = "none";
        document.getElementById("thirdSpan").style.display = "none";
        document.getElementById("secondSpan").innerHTML =
          "It seems the customer has not verifed his application through the link, which has been sent to his mobile number. To check again click ";
        spinner.setAttribute("hidden", "");
      }
      spinner.setAttribute("hidden", "");
    },
  },
  watch: {
    isProgress(value) {},
  },
};
</script>

<style  scoped>
@keyframes blink {
  /**
     * At the start of the animation the dot
     * has an opacity of .2
     */
  0% {
    opacity: 0.2;
  }
  /**
     * At 20% the dot is fully visible and
     * then fades out slowly
     */
  20% {
    opacity: 1;
  }
  /**
     * Until it reaches an opacity of .2 and
     * the animation can start again
     */
  100% {
    opacity: 0.2;
  }
}

.saving .dotAnimation {
  /**
     * Use the blink animation, which is defined above
     */
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  /**
     * This makes sure that the starting style (opacity: .2)
     * of the animation is applied before the animation starts.
     * Otherwise we would see a short flash or would have
     * to set the default styling of the dots to the same
     * as the animation. Same applies for the ending styles.
     */

  animation-fill-mode: both;
}

.dot {
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  height: 8px;
  width: 8px;
  background-color: #000000;
  border-radius: 50%;
  display: inline-block;
  margin-right: 15px;
}
.dotText {
  font-family: "Moderat", serif;
  font-weight: 300;
  font-size: 15px;
  color: #9e9e9e;
}
/* #promoButton:hover {
  text-decoration: underline;
} */

#promoButton > a {
  position: relative;
  color: #000000;
  text-decoration: none;
}

#promoButton > a:hover {
  color: #000000;
}
#promoButton > a:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  bottom: 0;
  right: 0;
  background-color: #000000;
  visibility: hidden;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transition: all 0.3s ease-in-out 0s;
  transition: all 0.3s ease-in-out 0s;
}

#promoButton > a:hover:before {
  visibility: visible;
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}
.consentStyle {
  font-family: "Moderat", serif;
  font-weight: 300;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0px;
  display: inline;
  color: #9e9e9e;
  cursor: pointer;
}
</style>
